import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class CountryDialogService {
  private readonly _openRequests = signal(0);
  readonly openRequests = this._openRequests.asReadonly();
  private readonly _lastOpenRequestSeen = signal(0);
  readonly lastOpenRequestSeen = this._lastOpenRequestSeen.asReadonly();

  requestOpen(): void {
    console.log('open country dialog');
    this._openRequests.update((v) => v + 1);
  }

  requestClose(): void {
    this._lastOpenRequestSeen.set(this._openRequests());
  }

  reset(): void {
    this._openRequests.set(0);
    this._lastOpenRequestSeen.set(0);
  }
}